import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-orm';
import { PollCapabilityConfiguration } from '../poll_configuration';
import { ScheduledPollDatastore } from './../datastore/scheduled_poll_datastore';
import { IScheduledPoll } from './../poll_interfaces';

export class ScheduledPollQuery {
  private _scheduledPolls: IterableIterator<IScheduledPoll>;
  private _currentScheduledPoll: IteratorResult<IScheduledPoll>;

  constructor(
    private ngScheduledPollDatastore: ScheduledPollDatastore,
    private completeScheduledPollCommand: ICommand,
    private dismissScheduledPollCommand: ICommand,
    private $q: ng.IQService,
    private ngPollCapabilityConfiguration: PollCapabilityConfiguration
  ) {
    ORM.registerQuery(this, ngScheduledPollDatastore);
  }

  run(): this {
    this._scheduledPolls = this.ngScheduledPollDatastore.read()[Symbol.iterator]();
    this._currentScheduledPoll = this._scheduledPolls.next();
    return this;
  }

  get result(): any {
    return this._scheduledPolls;
  }

  get currentScheduledPoll(): number | undefined {
    if (this._currentScheduledPoll.done) {
      return undefined;
    }
    return this._currentScheduledPoll.value.poll_id;
  }

  nextScheduledPoll(): number | undefined {
    this._currentScheduledPoll = this._scheduledPolls.next();
    if (this._currentScheduledPoll.done) {
      return undefined;
    }
    return this._currentScheduledPoll.value.poll_id;
  }

  finishedScheduledPolls(): boolean {
    return !!this._currentScheduledPoll.done;
  }

  continueScheduledPollsWorkflow(): boolean {
    return !this._currentScheduledPoll.done;
  }

  hasScheduledPolls(): boolean {
    return !this._currentScheduledPoll.done;
  }

  isMandatory(): boolean {
    if (this._currentScheduledPoll.done) {
      return false;
    }
    return _4.get(this._currentScheduledPoll, 'value.mandatory', false);
  }

  isCompleted(): boolean {
    if (this._currentScheduledPoll.done) {
      return true;
    }
    return this.isCurrentPollCompleted();
  }

  markPollAsFinished(): void {
    if (this._currentScheduledPoll.done) {
      return;
    }
    this._currentScheduledPoll.value.isCompleted = true;
  }

  isShowResult(): boolean {
    return this.isCurrentPollCompleted();
  }

  isCurrentPollCompleted(): boolean {
    return _4.get(this._currentScheduledPoll, 'value.isCompleted', false);
  }

  isCurrentPollIntake(): boolean {
    return (
      _4.get(this._currentScheduledPoll, 'value.poll_id', 0) ===
      _4.toNumber(this.ngPollCapabilityConfiguration.config.intakeOrFirstTermID)
    );
  }

  isValidPoll(): boolean {
    return !_4.isUndefined(_4.get(this._currentScheduledPoll, 'value.poll_id', undefined));
  }

  completeCurrentScheduledPoll(): any {
    if (this.isValidPoll()) {
      /*
       * this is for intake survey edits. It's not a Scheduled
       * poll, so we only have the NK value and can't mark the
       * Scheduled version completed.
       */
      if (_4.get(this._currentScheduledPoll, 'value.isIntakeOrFirstTerm', false)) {
        return this.$q.resolve(true);
      }

      return this.completeScheduledPollCommand(this._currentScheduledPoll.value.id);
    }
    // we resolve a promise regardless to prevent the controllers
    // from .then / .finally on undefined
    return this.$q.resolve(true);
  }

  dismissCurrentScheduledPoll(): any {
    if (this.isValidPoll()) {
      /*
       * this is for intake survey edits. It's not a Scheduled
       * poll, so we only have the NK value and can't mark the
       * Scheduled version completed.
       */
      if (_4.get(this._currentScheduledPoll, 'value.isIntakeOrFirstTerm', false)) {
        return this.$q.resolve(true);
      }

      if (this.isCurrentPollCompleted()) {
        return this.completeCurrentScheduledPoll();
      }
      return this.dismissScheduledPollCommand(this._currentScheduledPoll.value.id);
    }
    // we resolve a promise regardless to prevent the controllers
    // from .then / .finally on undefined
    return this.$q.resolve(true);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/queries/scheduled_poll_query.ts